import { createFileRoute, redirect } from "@tanstack/react-router";

/** Dubblett av ordlistesidan – permanent omdirigering. */
export const Route = createFileRoute("/elbruk")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "elbruk" }, statusCode: 301 });
  },
});
